import React from 'react'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { Redirect, Route } from 'react-router'
import { UserTypes } from '../../util/constants'

const BusinessRoute = ({ path, component, ...props }) => {
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const userType = useSelector(userSelectors.userType)

    if (isLoggedIn && userType === UserTypes.Business) {
        return <Route path={path} component={component} {...props} />
    }

    return <Redirect to={'/app/business/sign-in'} />
}

export default BusinessRoute
